import { DateTime } from 'luxon';

export interface TimeFrameLocationSettingsFormFields {
  morningStartsAt?: string[];
  eveningStartsAt?: string[];
  nightStartsAt?: string[];
}
export interface TimeFrameLocationSettingsFormFieldsArray {
  communities: TimeFrameLocationSettingsFormFields[];
}

export interface TimeFrameLocationSettingsFormApiError {
  message?: string;
}
export const formatTimeWithAP = (timeString: string, is24hTimeFormat?: boolean) => {
  const timeFormat = is24hTimeFormat ? 'HH:mm' : 'h:mm a';
  const formatted = DateTime.fromFormat(timeString, 'HH:mm:ss').toFormat(timeFormat);
  return is24hTimeFormat ? formatted : formatted.toLowerCase();
};

export const calculateTimeDifference = (startTime: string, endTime: string): number => {
  const start = DateTime.fromFormat(startTime, 'HH:mm:ss');
  let end = DateTime.fromFormat(endTime, 'HH:mm:ss');

  // If end time is earlier than start time, add a day to end time
  if (end < start) {
    end = end.plus({ day: 1 });
  }

  const durationInMinutes = end.diff(start, 'minutes').minutes;

  return durationInMinutes / 60;
};
const getTimeString = (value: string[] | undefined): string => value?.[0] ?? '';

export const calculateTotalHours = (data: TimeFrameLocationSettingsFormFields) => {
  const morningEveningD = calculateTimeDifference(
    getTimeString(data?.morningStartsAt),
    getTimeString(data?.eveningStartsAt),
  );
  const eveningNightD = calculateTimeDifference(
    getTimeString(data?.eveningStartsAt),
    getTimeString(data?.nightStartsAt),
  );
  const nightMorningD = calculateTimeDifference(
    getTimeString(data?.nightStartsAt),
    getTimeString(data?.morningStartsAt),
  );
  return morningEveningD + eveningNightD + nightMorningD;
};
